import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteGroup = createAsyncThunk(
  'listGroups/fetchDeleteGroup',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteGroup(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteGroupSlice = createSlice({
  name: 'groups/delete',
  initialState,
  reducers: {
    resetDeleteGroup: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteGroup.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteGroup.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteGroup.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteGroupSlice.reducer
export const { resetDeleteGroup } = deleteGroupSlice.actions
